import { render, staticRenderFns } from "./patientinformation.vue?vue&type=template&id=61c1d721&scoped=true&"
import script from "./patientinformation.vue?vue&type=script&lang=js&"
export * from "./patientinformation.vue?vue&type=script&lang=js&"
import style0 from "./patientinformation.vue?vue&type=style&index=0&id=61c1d721&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1d721",
  null
  
)

export default component.exports